import type { IStyle } from 'fela';

import { shiftColor } from '../utils/shift-color';

import type { Theme } from '../types';

export const list: () => IStyle = () => ({
  listStyle: 'none',
  '> li > a': {
    textDecoration: 'none',
    borderBottomWidth: '1px',
    borderBottomColor: '#e5e7eb'
  },
  // A hairline between rows, but not under the last one.
  '> li:not(:last-child)': {
    boxShadow: 'inset 0 -1px 0 rgba(2, 20, 13, 0.08)'
  }
});

export const row: (theme?: Theme) => IStyle = (theme) => ({
  padding: '8px 20px',
  ':hover': {
    backgroundColor: shiftColor(theme?.text?.style?.backgroundColor ?? '#fff', -15)
  },
  // The link fills the row and lays out the icon, title and chevron, so the
  // whole row stays clickable while the list item keeps the padding.
  '> a': {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    minWidth: 0,
    color: 'inherit',
    textDecoration: 'none'
  }
});

export const icon: IStyle = {
  flexShrink: 0,
  opacity: 0.55
};

export const title: IStyle = {
  flexGrow: 1,
  minWidth: 0
};

export const chevron: IStyle = {
  flexShrink: 0,
  opacity: 0.5
};
